import React from 'react';
import { Application } from '@pixi/react';
import { useRecoilBridgeAcrossReactRoots_UNSTABLE } from 'recoil';

import { colors } from '@/constants';

import './pixi-elements';
import Game from './Game';

const GameStage = () => {
  const RecoilBridge = useRecoilBridgeAcrossReactRoots_UNSTABLE();

  return (
    <Application
      className="game"
      background={parseInt(`0x${colors.black}`, 16)}
      resizeTo={window}
      resolution={window.devicePixelRatio || 1}
      autoDensity
    >
      <RecoilBridge>
        <Game />
      </RecoilBridge>
    </Application>
  );
};

export default GameStage;
